$(document).ready(function(){

	var cookiesVal = Cookies.get('cookiesAlert');

	if (cookiesVal !== 'false') {
		showCookies();
	} else {
		hideCookies();
	}

	$('.close__cookies').on('click', function(){
		hideCookies();
		Cookies.set('cookiesAlert','false');
	});

	$('.decline__cookies').on('click', function(){
		Cookies.set('cookies','decline');
	});

	$('.allow__cookies').on('click', function(){
		Cookies.set('cookies','allow');
		var gaId = $('meta[name=ownerGoogleAnalyticsUID]').attr('content');
		var ga = "<!-- Google Analytics --><script>(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');ga('create', '" + gaId + "', 'auto');ga('send', 'pageview');</script><!-- END SEOmatic rendered SEO Meta -->";
		$('head').append(ga);
	});


	function showCookies(){
		$('.cookies__wrapper').animate({
			'bottom': 0,
		},'fast');
	}

	function hideCookies(){
		$('.cookies__wrapper').animate({
			'bottom': -155,
		},'fast');
	}
	
});